<template>
    <b-card>
        <b-row>
            <b-col lg="12">
                <b-card header="Select Date Range"
                        header-text-variant="white"
                        header-bg-variant="info"
                >
                    <b-form inline class="d-flex justify-content-between align-items-center">

                        <div class="d-flex align-items-center">

                            <date-picker
                                    v-model="start_date"
                                    placeholder="Start Date"
                                    class="f-1"
                            >
                            </date-picker> &nbsp;to&nbsp;
                            <date-picker
                                    v-model="end_date"
                                    placeholder="End Date"
                                    class="f-1"
                            >
                            </date-picker>
                        </div>

                        <b-button @click="loadItems()" variant="info" class="ml-2" :disabled="loading">Generate Report</b-button>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="6">
                <b-btn variant="success" :href="`${url}&export=1`" :disabled="loading">
                    <i class="fa fa-file-excel-o"></i> Export to Excel
                </b-btn>
            </b-col>
            <b-col lg="6" class="text-right mb-3">
                <b-form-input v-model="filter" placeholder="Type to Search" />
            </b-col>
        </b-row>
        <div class="table-responsive">

            <loading-card v-if="loading"></loading-card>

            <b-table bordered striped hover show-empty
                     :items="items"
                     :fields="fields"
                     :current-page="currentPage"
                     :per-page="perPage"
                     :filter="filter"
                     :sort-by.sync="sortBy"
                     :sort-desc.sync="sortDesc"
                     @filtered="onFiltered"
                     v-else
            >
                <template v-slot:cell(actions)="row">
                    <b-btn size="sm" @click="viewItem(row.item)">View</b-btn>
                </template>
                <template v-slot:cell(user_id)="row">
                    {{ row.item.user.name }}
                </template>
            </b-table>
        </div>

        <b-modal id="auditModal" title="Selected Audit" v-model="auditModal" size="lg">
            <b-container fluid>
                <b-row>
                    <h4>User Details</h4>
                    <table class="table table-striped">
                        <tr>
                            <th>Username</th>
                            <td>{{ selectedItem.user ? selectedItem.user.username : '' }}</td>
                        </tr>
                        <tr>
                            <th>IP Address</th>
                            <td>{{ selectedItem.ip_address }}</td>
                        </tr>
                        <tr>
                            <th>Date Modified</th>
                            <td>
                              <utc-time
                                  :time="selectedItem.created_at"
                                  :role="this.role"
                              />
                            </td>
                        </tr>
                        <tr>
                            <th>User Agent</th>
                            <td>{{ selectedItem.user_agent }}</td>
                        </tr>
                    </table>
                    <h4>Changed Instance</h4>
                    <table class="table table-striped">
                        <th>{{ selectedItem.auditable_type }}</th>
                        <td>{{ selectedItem.auditable_id }}</td>
                    </table>
                    <h4>Changed Values</h4>
                    <table class="table table-striped">
                        <thead>
                        <tr>
                            <th>Attribute</th>
                            <th>Old Value</th>
                            <th>New Value</th>
                        </tr>
                        </thead>
                        <tr v-for="(value, key) in selectedItem.new_values" :key="key">
                            <th>{{ key }}</th>
                            <td style="max-width: 125px; overflow: hidden;">{{ selectedItem.old_values[key] ? selectedItem.old_values[key] : '' }}</td>
                            <td style="max-width: 125px; overflow: hidden;">{{ selectedItem.new_values[key] ? selectedItem.new_values[key] : '' }}</td>
                        </tr>
                    </table>
                </b-row>
            </b-container>
            <div slot="modal-footer">
                <b-btn variant="default" @click="auditModal=false">Close</b-btn>
            </div>
        </b-modal>

        <b-row>
            <b-col lg="6" >
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
            </b-col>
            <b-col lg="6" class="text-right">
                Showing {{ perPage < totalRows ? perPage : totalRows }} of {{ totalRows }} results
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
    import UsesRole from "../../../mixins/UsesRole";
    import FormatsDates from "../../../mixins/FormatsDates";
    export default {
        mixins: [FormatsDates, UsesRole],

        props: {
            'businesses': {},
            userId: {
                type:    Number,
                default: 0
            },
        },

        data() {
            return {
                start_date: "",
                end_date: "",
                totalRows: 0,
                perPage: 15,
                currentPage: 1,
                sortBy: null,
                sortDesc: false,
                filter: null,
                loading : false,
                fields: [
                    {
                        key: 'created_at',
                        label: 'Date Modified',
                        sortable: true,
                        formatter: d => this.formatDateTimeFromUTC(d),
                    },
                    {
                        key: 'auditable_type',
                        label: 'Modified Type',
                        sortable: true,
                    },
                    {
                        key: 'auditable_id',
                        label: 'Modified ID',
                        sortable: true,
                    },
                    {
                        key: 'event',
                        label: 'Action',
                        sortable: true,
                    },
                    {
                        key: 'user_id',
                        label: "User",
                        sortable: true,
                    },
                    {
                        key: 'actions',
                        class: 'hidden-print'
                    }
                ],
                items: [],
                selectedItem: {},
                auditModal: false,
            }
        },

        mounted() {
            // this.loadItems();
        },

        computed: {
            url() {
                return `/${this.controller}/reports/audit-log?start=${this.start_date}&end=${this.end_date}&user_id=${this.userId}&json=1`;
            },
        },

        methods: {
            loadItems()
            {
                this.loading = true;
                axios.get(this.url)
                .then(response => {
                    this.items = response.data;
                    this.totalRows = response.data.length;
                })
                .finally( () => this.loading = false );
            },

            viewItem(item)
            {
                this.selectedItem = item;
                this.auditModal = true;
            },

            onFiltered(filteredItems) {
                // Trigger pagination to update the number of buttons/pages due to filtering
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            }
        }
    }
</script>